// @ts-nocheck
import React, { useState } from 'react';
import { useAlias } from "./State/AliasContext";
import { styled } from '@mui/material/styles';
import BuscadorAlias from "./Componentes/BuscadorAlias"
import ListaAlias from "./ListaAlias";
import AliasSkeletonList from "./Componentes/AliasSkeletonList";
import { AliasForm } from "./AltaAlias";
import { ModalGeneral } from "../Componentes/ModalGeneral";
import VistaAlias from "./VistaAlias";
import { DeleteAlias } from "./Componentes/DeleteAlias";
import { useBody } from "../Body/state/BodyContext";

const InicioDeAlias = () => {
    const { alias, setAlias, aliases, setAliases, openVista,
        setOpenVista, openEditar, setOpenEditar, openEliminar, setOpenEliminar, loadingAlias } = useAlias()
    const { setMessage } = useBody();

    const handleOpenVista = () => {
        setOpenVista(true)
    };
    const onCloseVista = () => {
        setOpenVista(false)
    }
    const handleOpenEditar = () => {
        setOpenEditar(true)
    };
    const onCloseEditar = () => {
        setOpenEditar(false)
    }
    const handleOpenEliminar = () => {
        setOpenEliminar(true)
    };
    const onCloseEliminar = () => {
        setOpenEliminar(false)
    }

    return (
        <>
            <BuscadorAlias
                setAliases={setAliases}
            />
            {loadingAlias ? (
                <AliasSkeletonList />
            ) : aliases.length !== 0 && (
                <ListaAlias
                    alias={alias}
                    setAlias={setAlias}
                    aliases={aliases}
                    setAliases={setAliases}
                />
            )}
            <ModalGeneral
                Contenido={<VistaAlias />}
                open={openVista}
                handleOpen={handleOpenVista}
                onClose={onCloseVista}
            />
            <ModalGeneral
                titulo="Editar Alias"
                subtitulo={"Modifique los datos del alias"}
                Contenido={<AliasForm alias={alias} method="PUT" onClose={onCloseEditar} />}
                open={openEditar}
                handleOpen={handleOpenEditar}
                onClose={onCloseEditar}
            />
            <DeleteAlias
                open={openEliminar}
                onClose={onCloseEliminar}
            />

        </>
    );
};

export default InicioDeAlias;
